import type { ComputedRef, Ref } from 'vue';
import {
  computed,

  ref,

} from 'vue';

import type { ITableMultiselectActionParams } from '@modules/tables/components/VTable/types';
import type { ITableFilterProps } from '@modules/tables/components/VTableFilter/types';
import type { ITableMultiselectActions } from '@modules/tables/types';
import { useAffiliatesTranslate } from '@modules/affiliates-approved/composables';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { usePermissionsStore } from '@modules/permissions/store';

export interface AffiliatesListComposable {
  showChangeManagerDialog: Ref<boolean>;
  showChangeNncoDialog: Ref<boolean>;
  showChangeDepartmentDialog: Ref<boolean>;
  tableFilterOptions: ITableFilterProps;
  multiselectOptions: ComputedRef<ITableMultiselectActions>;
  handleMultiselectAction(data: ITableMultiselectActionParams): void;
  selectedIds: Ref<number[]>;
}

export default function useAffiliatesList(): AffiliatesListComposable {
  const { hasPermission } = usePermissionsStore();
  const { translate } = useAffiliatesTranslate();

  const showChangeManagerDialog = ref(false);
  const showChangeNncoDialog = ref(false);
  const showChangeDepartmentDialog = ref(false);
  const tableFilterOptions: ITableFilterProps = {
    pathForFilter: 'api2/admin/affiliates',
    actionForFilter: 'list_approved',
    filterName: 'affiliate',
  };

  const multiselectOptions = computed<ITableMultiselectActions>(() => {
    const actions: ITableMultiselectActions = {};

    if (hasPermission(AFFILIATES_APPROVED_PERMISSIONS.CHANGE_MANAGER_FOR_AFFILIATES).value) {
      actions.changeManager = {
        label: translate('CHANGE_MANAGER_ACTION'),
      };
    }

    if (hasPermission(AFFILIATES_APPROVED_PERMISSIONS.CHANGE_NNCO_FOR_AFFILIATES).value) {
      actions.changeNnco = {
        label: translate('CHANGE_NNCO_ACTION'),
      };
    }

    if (hasPermission(AFFILIATES_APPROVED_PERMISSIONS.UPDATE_DEPARTMENT_FOR_AFFILIATES).value) {
      actions.changeDepartment = {
        label: translate('CHANGE_DEPARTMENT_ACTION'),
      };
    }

    return actions;
  });

  const selectedIds = ref<number[]>([]);

  function handleMultiselectAction(data: ITableMultiselectActionParams): void {
    selectedIds.value = data.selection;

    switch (data.actionId) {
      case 'changeManager':
        showChangeManagerDialog.value = true;
        break;
      case 'changeNnco':
        showChangeNncoDialog.value = true;
        break;
      case 'changeDepartment':
        showChangeDepartmentDialog.value = true;
        break;
      default:
        break;
    }
  }

  return {
    showChangeManagerDialog,
    showChangeNncoDialog,
    showChangeDepartmentDialog,
    tableFilterOptions,
    selectedIds,
    multiselectOptions,
    handleMultiselectAction,
  };
}
